import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  Form,
  useDispatch,
  connect,
  useRouter,
} from "../../atoms/DependencyHelper";
import DeliveryAddress from "../../atoms/checkoutForms/deliveryAddress/DeliveryAddress";
import BillingAddress from "../../atoms/checkoutForms/billingAddress/BillingAddress";
import PersonDetails from "../../atoms/checkoutForms/personDetails/PersonDetails";
import CompanyVat from "../../atoms/checkoutForms/companyVat/CompanyVat";
import FormHeading from "../../atoms/checkoutForms/formHeading/FormHeading";
import CheckoutFormsModal from "../../molecules/modals/checkoutFormsModal/CheckoutFormsModal";
import DeliveryTitle from "../../atoms/deliveryTitle/DeliveryTitle";
import DeliveryOptionTitle from "../../atoms/DeliveryOptionTitle/DeliveryOptionTitle";
import AddressTile from "../../atoms/addressTile/AddressTile";
import AddAddress from "../../atoms/addAddress/AddAddress";
import PageHeading from "../../atoms/pageHeading/PageHeading";
import styles from "./CheckoutDelivery.module.scss";
import ContentSearchBox from "../../atoms/contentSearchBox/ContentSearchBox";
import ConfirmModal from "../../atoms/confirmModal/ConfirmModal";
import TermsCheckbox from "../../atoms/checkoutForms/termsCheckbox/TermsCheckbox";
import config from "../../../config/index";
import errorMessages from "../../../config/errorMessages";
import ajaxService from "../../../utils/ajaxServices";
import labels from "../../../config/labels";
import {
  getAllCustomerAddressListsService,
  setNewShippingAddressService,
  setExistingShippingAddressService,
  setNewBillingAddressService,
  setExistingBillAddressService,
  deleteCustomerAddressService,
  setGuestEmailOnCartService,
  setShippingMethodsOnCartService,
  updateProfileDataService,
  getGeographicSiteStockService,
  getCordsService,
} from "../../../services/checkoutService";
import {
  imagePrefix,
  urlPrefix,
  showSpinner,
  hideSpinner,
  getUpdatedSurname,
  africaCountryCode,
  matchWordInString,
  getCookieValue,
  generateFormURL,
  // TODO: switch into getCustomerPositionAsync
  getCustomerPosition,
  getCustomerPositionAsync,
  checkPreOrder,
} from "../../../utils/helperServices";
import {
  SET_SHIPPING,
  SET_BILLING,
  SET_SHIPPING_METHOD,
} from "../../../Redux/actionTypes/index";
import { setReLogin } from "../../../Redux/actions/navAction";
import {
  setGeoLocationStatus,
  setGeoLocationPosition,
  setStoreDetails,
  setChangeStore,
} from "../../../Redux/actions/geoLocationAction";
import * as Analytics from "../../../services/analyticsUtag";
import StoreCard from "../../atoms/storeCard/storeCard";
import ReceiveType from "../../molecules/receiveType/ReceiveType";
import LabelText from "../../atoms/label/LabelText";
import DropDownComponent from "../../atoms/dropDown/DropDown";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import EmptyProductsContainer from "../emptyProductsContainer/EmptyProductsContainer";
import { journeyType } from "../../../context/checkout-journey-context";
import { storeListData, deliveryDetailsCBU } from "../../../data/StoreListData";
import getStoreLists from "../../../utils/getStoreList";

const CheckoutDelivery = forwardRef(
  (
    {
      addressTypes,
      statesTypes,
      continueDisable,
      countryCode,
      countryName,
      cartId,
      navigate,
      shippingMessageText,
      shippingFeeCalculateAmount,
      subTotal,
      shippingAddress,
      billingAddress,
      isGuestUser,
      profileData,
      customerStatus,
      setShowSnackBar,
      setPageErr,
      profileLoading,
      geoLocation,
      setReLogin,
      setGeoLocationStatus,
      setGeoLocationPosition,
      setStoreDetails,
      applicationType,
      currentJourneyType,
      cartDetails,
      deliveryDetails,
      authDetailsData,
      upgradeResponse,
      clickAndCollectEnabled,
      carrierCode,
      methodCode,
      dealID,
      storeCollectDisabled,
      clickAndCollectDelivery,
    },
    ref
  ) => {
    const [dataFail, setDataFail] = useState(false);
    const [showContactDetails, setShowContactDetails] = useState(false);
    const [showBillingAddress, setShowBillingAddress] = useState(false);

    const [finalAddress, setFinalAddress] = useState([]);
    const [customerData, setCustomerData] = useState({
      firstName: "",
      surName: "",
      email: "",
      cellNumber: "",
    });
    const [selectedDeliveryAddress, setSelectedDeliveryAddress] =
      useState(false);
    const [selectedBillingAddress, setSelectedBillingAddress] = useState(true);
    const [selectedReceiveType, setSelectedReceiveType] = useState(geoLocation?.storeDetails ? geoLocation?.changeMethods  ? "courier": "store" : "courier");
    const [modalType, setModalType] = useState("delivery");
    const [modalVariant, setModalVariant] = useState("add");
    const [modalValues, setModalValues] = useState({});
    const [modalShow, setModalShow] = useState(false);
    const [selectedClosestStoreCard, setSelectedClosestStoreCard] =
      useState(" ");
    const [submitAttempt, setSubmitAttempt] = useState(0);
    const [storeLists, setStoreLists] = useState([]);
    const [closestStoreLists, setClosestStoreLists] = useState([]);
    const [storeListsFromSearch, setStoreListsFromSearch] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [confirmModalContent, setConfirmModalContent] = useState("");
    const [deleteId, setDeleteId] = useState(null);
    const [deleteType, setDeleteType] = useState("");
    const [selectedAddress, setSelectedAddress] = useState("");
    const [deliveryAnalytics, setDeliveryAnalytics] = useState(false);
    const [contactAnalytics, setContactAnalytics] = useState(false);
    const [viewSent, setViewSent] = useState(false);
    const [courierPath, setCourierPath] = useState([]);
    const [storePath, setStorePath] = useState([]);
    const addressTypesOptions = addressTypes ? addressTypes : [];
    const stateTypesOptions = statesTypes ? statesTypes : [];
    const RESIDENTIAL_ADDRESS_TYPE =
      addressTypesOptions && addressTypesOptions.length > 0
        ? addressTypesOptions[0]?.id
        : "";
    const BUSINESS_ADDRESS_TYPE =
      addressTypesOptions && addressTypesOptions.length > 0
        ? addressTypesOptions[1]?.id
        : "";
    const POSTAL_ADDRESS_TYPE =
      addressTypesOptions && addressTypesOptions.length > 0
        ? addressTypesOptions[2]?.id
        : "";

    const titleContents = [
      shippingMessageText &&
        shippingFeeCalculateAmount &&
        subTotal > shippingFeeCalculateAmount &&
        shippingMessageText.free_shipping_message +
          ", " +
          shippingMessageText.free_shipping_method_message,
      shippingMessageText && shippingMessageText.delivery_message,
    ];
    const [serviceDown, setServiceDown] = useState(false);
    const [deliveryOptionEnable, setDeliveryOptionEnable] = useState(false);
    const [deliveryAddresslists, setDeliveryAddresslists] = useState([]);
    const [billingAddresslists, setBillingAddresslists] = useState([]);
    const [totalDeliveryAddress, setTotalDeliveryAddress] = useState(0);
    const [dataSize, setDataSize] = useState(3);
    const [selectedStoreCard, setSelectedStoreCard] = useState(" ");
    const [customerPosition, setCustomerPosition] = useState({});
    const [selectedStoreAddressItem, setSelectedStoreAddressItem] = useState(
      {}
    );
    const [selected, setSelected] = useState();
    const [searchResult, setSearchResult] = useState(false);
    const [tabDisable, setTabDisable] = useState(geoLocation?.changeMethods ? true : false);
    const numRegEx = RegExp(/^[0-9]*$/);
    const cellPhoneRegEx = RegExp(/^0|27[0-9]*$/);
    const streetNameRegEx = RegExp(/^[a-zA-Z0-9_ ]*$/);
    const emailRegEx = RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
    const router = useRouter();
    const dispatch = useDispatch();
    const [storeDataDetails, setStoreDataDetails] = useState({});
    const analyticsData = Analytics.getUtagData();
    const [dropdownWithDistance, setDropdownWithDistance] = useState([
      { label: "Distance" },
      { label: "Alphabetical (A-Z)" },
      { label: "Alphabetical (Z-A)" },
    ]);

    const [dropdownValues, setDropdownValues] = useState([
      { label: "Alphabetical (A-Z)" },
      { label: "Alphabetical (Z-A)" },
    ]);

    const contactFormInfo =
      applicationType == "normal"
        ? null
        : {
            icon: `${imagePrefix}/assets/images/info_teal.svg`,
            desc: labels.delivery.contractTypeContactFormInfo,
          };

    useEffect(() => {
      if (customerStatus && !viewSent) {
        if (applicationType == "normal") {
          Analytics.view({
            page_event: "view",
            page_name: `checkout: delivery: ${customerStatus}`,
            page_channel: "checkout",
            page_master_tab: "personal",
            ...Analytics.getProfileData(!isGuestUser, profileData, authDetailsData),
          });
        } else {
          if (currentJourneyType == journeyType.upgrade) {
            Analytics.view({
              page_event: "view",
              page_name: `checkout: delivery: ${customerStatus}`,
              page_channel: "checkout",
              page_master_tab: "personal",
              delivery_type:
                deliveryDetails?.receiveType == "store" ? "collect" : "deliver",
              authentication_id_type:
                authDetailsData?.idType == "PASSPORT" ? "passport" : "id",
              upgrade_eligibility_status: upgradeResponse?.eligibilityStatus,
              upgrade_eligible_date: upgradeResponse?.upgradeDate || "",
              upgrade_customer_type: upgradeResponse?.c3dCustomer
                ? "C3D"
                : upgradeResponse?.business
                ? "CBU"
                : "OTHER",
              ...Analytics.getProfileData(!isGuestUser, profileData, authDetailsData),
            });
          } else {
            Analytics.view({
              page_event: "view",
              page_name: `checkout: delivery: ${customerStatus}`,
              page_channel: "checkout",
              page_master_tab: "personal",
              delivery_type:
                deliveryDetails?.receiveType == "store" ? "collect" : "deliver",
              authentication_id_type:
                authDetailsData?.idType == "PASSPORT" ? "passport" : "id",

              ...Analytics.getProfileData(!isGuestUser, profileData, authDetailsData),
            });
          }
        }
        setViewSent(true);
      }
    }, [customerStatus]);

    /* Enable when single devcice deals data dependecy resolved for Clcik and collect */
    // const enableClickAndCollect = () => {
    //   let physicalDevice = [], counter = 0;
    //   if (clickAndCollectDelivery) {
    //     cartDetails?.cartProductItems[0]?.product?.items.map(item => {
    //     item?.options.map(deviceOption => {
    //         if (deviceOption?.is_hidden_product == "1" && deviceOption?.price > 0) {
    //           physicalDevice.push(deviceOption?.product?.sku);
    //           counter += 1;
    //         }
    //       })
    //     })
    //     if (counter == 1) {
    //         return true;
    //     }
    //     return false;
    //   }
    // }

    async function featuresCheck() {
      if (clickAndCollectEnabled) {
        setDeliveryOptionEnable(true);
        tabDisable ? setTabDisable(true) : checkPreOrder(cartDetails?.cartProductItems) ? setTabDisable(true) : setTabDisable(false);
      } else {
        setSelectedReceiveType("courier");
        setDeliveryOptionEnable(false);
      }
    }

    useEffect(() => {
      featuresCheck();
      fetchPathData();
      if (storeCollectDisabled) {
        setSelectedReceiveType("courier");
      }

      if (selectedReceiveType == "store") {
        setSelected("Alphabetical (A-Z)");
        if (!geoLocation?.allowed) {
          getCustomerPositionAsync().then(
            (resultData) => {
              const latitude = resultData.result?.latitude;
              const longitude = resultData.result?.longitude;
              if (!!(latitude && longitude)) {
                setCustomerPosition(resultData?.result);
                setSelected("Distance");
                setGeoLocationPosition({
                  latitude: latitude,
                  longitude: longitude,
                });
                setGeoLocationStatus(true);
                getStoreLists(
                  resultData.result,
                  dealID,
                  setStoreLists,
                  setServiceDown
                );
              }
            },
            (resultDataFailure) => {
              setServiceDown(true);
              console.log({ resultDataFailure });
            }
          );
        } else {
          if (geoLocation?.allowed) {
            let locations = {
              result: {
                latitude: geoLocation?.latitude,
                longitude: geoLocation?.longitude,
              },
            };
            setCustomerPosition(locations);
            setSelected("Distance");
            getStoreLists(
              locations?.result,
              dealID,
              setStoreLists,
              setServiceDown
            );
          }
        }
      }
    }, [selectedReceiveType]);

    useEffect(() => {
      if (
        selectedReceiveType == "store" &&
        storeLists &&
        storeLists.length > 0
      ) {
        let listItems = storeLists.filter(
          (listItem) => listItem?.inStock != false
        );
        if (geoLocation?.storeDetails) {
          closestStoreCardClickHandler(listItems.findIndex(ele => ele.storeID === geoLocation?.storeDetails), listItems.find(ele => {return ele.storeID === geoLocation?.storeDetails}));
        }
        setClosestStoreLists(listItems);
      }
    }, [storeLists]);

    const passSuggestedData = (filteredAddressData) => {
      if (filteredAddressData.length == 0) {
        setSearchResult(true);
        setStoreListsFromSearch([]);
      }
    };

    useEffect(() => {
      refreshState();
      if (!isGuestUser && !profileLoading) {
        fetchData();
      }
    }, [profileLoading]);

    useEffect(() => {
      if (
        Object.keys(finalAddress).length != 0 &&
        selectedReceiveType == "store"
      ) {
        let resultData = { result: { latitude: "", longitude: "" } };
        resultData.result.latitude = finalAddress?.geometry?.location?.lat;
        resultData.result.longitude = finalAddress?.geometry?.location?.lng;
        getStoreLists(
          resultData.result,
          dealID,
          setStoreListsFromSearch,
          setServiceDown
        );
        setSearchResult(false);
      } else {
        addressSearchResultMap();
      }
    }, [finalAddress]);

    useEffect(() => {
      if (addressTypesOptions.length > 0) {
        fieldValues.delivery.addressType = RESIDENTIAL_ADDRESS_TYPE;
        fieldValues.billing.addressType = RESIDENTIAL_ADDRESS_TYPE;
        fieldValues.companyInformation.addressType = BUSINESS_ADDRESS_TYPE;

        setState({
          ...state,
          fieldValues,
        });
      }
    }, [addressTypesOptions]);

    useEffect(() => {
      if (stateTypesOptions.length > 0) {
        fieldValues.delivery.province = stateTypesOptions[0].id;
        fieldValues.billing.province = stateTypesOptions[0].id;
        fieldValues.companyInformation.province = stateTypesOptions[0].id;

        setState({
          ...state,
          fieldValues,
        });
      }
    }, [stateTypesOptions]);

    useEffect(() => {
      if (dataFail) {
        continueDisable(true);
      } else {
        if (
          totalDeliveryAddress == 0 &&
          !checkFormError("delivery") &&
          !checkFormError("details") &&
          !checkFormError("contactDetails") &&
          selectedBillingAddress
        ) {
          continueDisable(false);
        } else if (
          totalDeliveryAddress !== 0 &&
          selectedDeliveryAddress &&
          (applicationType == "normal"
            ? selectedBillingAddress
            : !checkFormError("details"))
        ) {
          continueDisable(false);
        } else {
          continueDisable(true);
        }
      }
    }, [
      dataFail,
      totalDeliveryAddress,
      selectedDeliveryAddress,
      selectedBillingAddress,
    ]);

    const handleSizeChange = (size) => {
      setDataSize(size);
    };

    const receiveTypesOptions = [
      {
        id: "courier",
        label: "Deliver via courier",
        hide: false,
        img: "Path.svg",
      },
      {
        id: "store",
        label: "Collecting in store",
        hide: storeCollectDisabled,
        img: "Collect.svg", // change to C&C icon when available
      },
    ];

    const handleReceiveType = async (val, index) => {
      setSelectedReceiveType(val);
    };

    const storeCardClickHandler = (id, item) => {
      if (item?.inStock != false) {
        setStoreDataDetails(item);
        setSelectedStoreCard(id);
        const pageName = Analytics.getUtagData(["page_name"]).page_name;
        Analytics.link({
          link_type: "o",
          page_tool_event: "use",
          page_tool_name: `${pageName}: store selection`,
          filter_query: item.name,
        });
        setStoreDetails(item.storeID);
        setChangeStore(null);
        continueDisable(false);
      }
    };

    const closestStoreCardClickHandler = (id, item) => {
      setStoreDataDetails(item);
      setSelectedClosestStoreCard(id);
      const pageName = Analytics.getUtagData(["page_name"]).page_name;
      Analytics.link({
        link_type: "o",
        page_tool_event: "use",
        page_tool_name: `${pageName}: store selection`,
        filter_query: item.name,
      });
      setStoreDetails(item.storeID);
      setChangeStore(null);
      continueDisable(false);
    };

    async function fetchPathData() {
      let url = 'paidDeliveryCheckoutPath';
      if (cartDetails &&
          cartDetails?.shippingFeeCalculate?.carrier_code == 'freeshipping') {
        url = 'checkoutPath';
      }

      let resultsPath = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        url
      );
      if (resultsPath?.status == "success") {
        courierPath.push(resultsPath.sections[0].items[0]);
        storePath.push(resultsPath.sections[0].items[1]);
      }
    }

    const mapDeliveryOnStoreFieldData = () => {
      if (storeDataDetails) {
        return {
          cart_id: cartId !== "" ? cartId : null,
          region:
            storeDataDetails && storeDataDetails?.state
              ? storeDataDetails?.state == "Southern Gauteng"
                ? "Gauteng"
                : storeDataDetails?.state
              : null,
          country_code: countryCode ? countryCode : null,
          instructions: null,
          street: createStreetFromAddressLines(
            storeDataDetails?.addressLineOne,
            storeDataDetails?.addressLineTwo
          ),
          postcode: storeDataDetails?.postalCode,
          city: storeDataDetails?.city,
          address_type_name: storeDataDetails?.storeID,
          address_name: "Store",
          company: null,
          unit_number: null,
          complex_name: null,
          street_number: null,
          suburb: storeDataDetails?.district
            ? storeDataDetails?.district
            : storeDataDetails?.city,
          firstname: customerData?.firstName,
          lastname: customerData.surName
            ? customerData?.surName
            : customerData?.firstName,
          telephone: customerData?.cellNumber,
          save_in_address_book: false,
          is_shipping_address: 0,
          is_billing_address: 0,
        };
      }
    };

    useImperativeHandle(ref, () => ({
      submit: () => {
        Analytics.link({
          link_type: "o",
          link_name: `checkout: delivery: ${customerStatus}: continue`,
        });

        //Close warning snack bar if there is any
        closeSnackBar();

        if (applicationType == "normal") {
          if (isGuestUser) {
            addEmailAddress();
          } else if (
            totalDeliveryAddress == 0 &&
            (customerData.firstName == "" ||
              getUpdatedSurname(customerData.surName) == "" ||
              customerData.email == "" ||
              !customerData.email ||
              customerData.cellNumber == "" ||
              !customerData.cellNumber)
          ) {
            profileUpdate();
          } else {
            addDeliveryAddress();
          }
        } else {
          if (selectedReceiveType == "store") {
            addDeliveryAddress();
          } else {
            if (
              customerData.firstName == "" ||
              getUpdatedSurname(customerData.surName) == "" ||
              customerData.email == "" ||
              !customerData.email ||
              customerData.cellNumber == "" ||
              !customerData.cellNumber
            ) {
              profileUpdate();
            } else {
              addDeliveryAddress();
            }
          }
        }
      },
      back: () => {
        if (applicationType == "normal") {
          Analytics.link({
            link_type: "o",
            link_name: `checkout: delivery: ${customerStatus}: back to cart`,
          });
        } else {
          Analytics.link({
            link_type: "o",
            link_name: `checkout: delivery: ${customerStatus}: back to lets get started`,
          });
        }
      },
    }));

    const fetchData = async () => {
      try {
        showSpinner();
        let results = await getAllCustomerAddressListsService();

        if (!results.fail) {
          await customerDetails(results.customerData);
          await filterAddressLists(results.addressList);
          setDataFail(false);
          hideSpinner();
        } else {
          setDataFail(true);
          hideSpinner();
          if (results && results.errors) {
            technicalFailure(results.errors?.[0]?.message);
          } else {
            technicalFailure();
          }
        }
      } catch {
        hideSpinner();
        technicalFailure();
      }
    };

    function customerDetails(customerData) {
      let newSurName = getUpdatedSurname(customerData.surName);

      fieldValues.details.firstName = customerData.firstName
        ? customerData.firstName
        : "";
      fieldValues.details.surName = newSurName ? newSurName : "";
      fieldValues.details.email = customerData.email ? customerData.email : "";
      fieldValues.details.cellNumber = customerData.telephone
        ? customerData.telephone
        : "";
      errorStatus.details = checkFormError("details");

      let newCustomerData = {
        firstName: customerData.firstName,
        surName: newSurName,
        email: customerData.email,
        cellNumber: customerData.telephone,
      };

      setCustomerData(newCustomerData);

      setState({
        ...state,
        fieldValues,
        errorStatus,
      });
    }

    const getProvinceValue = (name) => {
      var finalID = statesTypes.filter((item) => item.code == name);
      if (finalID && finalID[0] && finalID[0].id) {
        return finalID[0].id;
      }
    };

    const filterAddressLists = (addressLists) => {
      if (addressLists && addressLists.length > 0) {
        let deliveryLists = [];
        let billingLists = [];

        addressLists.map((address) => {
          if (address.is_shipping_address) {
            deliveryLists.push(address);

            if (
              shippingAddress &&
              shippingAddress.customer_address_id &&
              shippingAddress.customer_address_id == address.id
            ) {
              setSelectedDeliveryAddress(shippingAddress.customer_address_id);
            } else if (
              address.default_shipping &&
              address.default_shipping == true &&
              !selectedDeliveryAddress
            ) {
              setSelectedDeliveryAddress(address.id);
            }
          }

          if (address.is_billing_address && applicationType == "normal") {
            billingLists.push(address);

            if (
              billingAddress &&
              billingAddress.customer_address_id &&
              billingAddress.customer_address_id == address.id
            ) {
              setSelectedBillingAddress(billingAddress.customer_address_id);
            } else if (
              address.default_billing &&
              address.default_billing == true &&
              !selectedBillingAddress
            ) {
              setSelectedBillingAddress(address.id);
            }
          }
        });

        setTotalDeliveryAddress(deliveryLists.length);
        setDeliveryAddresslists(deliveryLists);
        setBillingAddresslists(billingLists);
      } else {
        setTotalDeliveryAddress(0);
        setDeliveryAddresslists([]);
        setBillingAddresslists([]);

        errorStatus.delivery = true;
        setState({
          ...state,
          errorStatus,
        });
      }
    };

    const seperateStreetString = (str) => {
      if (str && str !== "") {
        return str.split(", ");
      } else {
        return null;
      }
    };

    const getRegionValue = (id) => {
      return id && id !== "" ? statesTypes.find((item) => item.id == id) : null;
    };

    const createStreetFromAddressLines = (str1, str2) => {
      let res = [];
      if (str1) {
        res.push(str1);
      }

      if (str2) {
        res.push(str2);
      }
      return res;
    };

    const [state, setState] = useState({
      validationsOn: {
        delivery: true,
        billing: false,
        companyInformation: false,
        details: true,
        contactDetails: false,
      },
      errorStatus: {
        delivery: false,
        billing: false,
        companyInformation: false,
        details: false,
        contactDetails: false,
      },
      validations: {
        delivery: {
          addressName: true,
          addressType: true,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: false,
          complexName: false,
          streetNo: true,
          streetName: true,
          suburb: true,
          postalCode: true,
          town: true,
          province: true,
          instructions: false,
          futureCheck: false,
          contactCheck: false,
        },
        billing: {
          addressName: true,
          addressType: true,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: false,
          complexName: false,
          streetNo: false,
          streetName: true,
          suburb: true,
          postalCode: true,
          town: true,
          province: true,
          instructions: false,
          addressCheck: false,
        },
        companyInformation: {
          addressName: false,
          addressType: true,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: true,
          complexName: true,
          streetNo: true,
          streetName: true,
          suburb: true,
          postalCode: true,
          town: true,
          province: true,
          instructions: false,
          companyVatName: true,
          companyVatNumber: true,
          informationCheck: false,
          ciaddressCheck: false,
          cifutureCheck: false,
        },
        details: {
          firstName: true,
          surName: true,
          cellNumber: true,
          email: true,
          contactCheck: false,
        },
        contactDetails: {
          firstName: true,
          surName: true,
          cellNumber: true,
        },
      },
      fieldErrors: {
        delivery: {
          addressName: false,
          addressType: false,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: false,
          complexName: false,
          streetNo: false,
          streetName: false,
          suburb: false,
          postalCode: false,
          town: false,
          province: false,
          instructions: false,
          futureCheck: false,
          contactCheck: false,
        },
        billing: {
          addressName: false,
          addressType: false,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: false,
          complexName: false,
          streetNo: false,
          streetName: false,
          suburb: false,
          postalCode: false,
          town: false,
          province: false,
          instructions: false,
          addressCheck: false,
        },
        companyInformation: {
          addressName: false,
          addressType: false,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: false,
          complexName: false,
          streetNo: false,
          streetName: false,
          suburb: false,
          postalCode: false,
          town: false,
          province: false,
          instructions: false,
          companyVatName: false,
          companyVatNumber: false,
          informationCheck: false,
          ciaddressCheck: false,
          cifutureCheck: false,
        },
        details: {
          firstName: false,
          surName: false,
          cellNumber: false,
          email: false,
          contactCheck: false,
        },
        contactDetails: {
          firstName: false,
          surName: false,
          cellNumber: false,
        },
        fail: false,
      },
      fieldValues: {
        delivery: {
          addressName: "",
          addressType: RESIDENTIAL_ADDRESS_TYPE,
          companyName: "",
          addressLine1: "",
          addressLine2: "",
          unitNo: "",
          complexName: "",
          streetNo: "",
          streetName: "",
          suburb: "",
          postalCode: "",
          town: "",
          province: "",
          instructions: "",
          futureCheck: false,
          contactCheck: true,
        },
        billing: {
          addressName: "",
          addressType: "",
          companyName: "",
          addressLine1: "",
          addressLine2: "",
          unitNo: "",
          complexName: "",
          streetNo: "",
          streetName: "",
          suburb: "",
          postalCode: "",
          town: "",
          province: "",
          instructions: "",
          addressCheck: true,
        },
        companyInformation: {
          addressName: "",
          addressType: "",
          companyName: "",
          addressLine1: "",
          addressLine2: "",
          unitNo: "",
          complexName: "",
          streetNo: "",
          streetName: "",
          suburb: "",
          postalCode: "",
          town: "",
          province: "",
          instructions: "",
          companyVatName: "",
          companyVatNumber: "",
          informationCheck: false,
          ciaddressCheck: true,
          cifutureCheck: true,
        },
        details: {
          firstName: "",
          surName: "",
          cellNumber: "",
          email: "",
          contactCheck: true,
        },
        contactDetails: {
          firstName: "",
          surName: "",
          cellNumber: "",
        },
      },
      readOnlyValues: {
        delivery: {
          addressName: false,
          addressType: false,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: false,
          complexName: false,
          streetNo: false,
          streetName: false,
          suburb: false,
          postalCode: false,
          town: false,
          province: false,
          instructions: false,
        },
        billing: {
          addressName: false,
          addressType: false,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: false,
          complexName: false,
          streetNo: false,
          streetName: false,
          suburb: false,
          postalCode: false,
          town: false,
          province: false,
          instructions: false,
        },
        companyInformation: {
          addressName: false,
          addressType: false,
          companyName: false,
          addressLine1: false,
          addressLine2: false,
          unitNo: false,
          complexName: false,
          streetNo: false,
          streetName: false,
          suburb: false,
          postalCode: false,
          town: false,
          province: false,
          instructions: false,
          companyVatName: false,
          companyVatNumber: false,
        },
        details: {
          firstName: false,
          surName: false,
          cellNumber: false,
          email: false,
        },
        contactDetails: {
          firstName: false,
          surName: false,
          cellNumber: false,
        },
      },
      fieldErrorsMessage: {
        delivery: {
          addressName: "Please enter address type (e.g. Home, Work)",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions",
        },
        billing: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions",
        },
        companyInformation: {
          addressName: "Please enter a name for this address",
          addressType: "Please select your address type",
          companyName: "Please enter your company name",
          addressLine1: "Please enter your postal address(Line 1)",
          addressLine2: "Please enter your postal address(Line 2)",
          unitNo: "Please enter a unit no.",
          floorNo: "Please enter a unit / floor no.",
          complexName: "Please enter your complex name",
          officeComplexName: "Please enter your office park / building name",
          streetNo: "Please enter your street no.",
          streetName: "Please enter your street name",
          suburb: "Please enter and select suburb",
          postalCode: "Please enter your postal code",
          town: "Please enter your town/city name",
          province: "Please select your province",
          instructions: "Please enter special instructions",
          companyVatName: "Please enter your company name",
          companyVatNumber: "Please enter your company VAT number",
        },
        details: {
          firstName: "Please enter your first name",
          surName: "Please enter your surname",
          cellNumber: "Please enter your cellphone number",
          email: "Please enter your email address",
        },
        contactDetails: {
          firstName: "Please enter your first name",
          surName: "Please enter your surname",
          cellNumber: "Please enter a cellphone number",
        },
      },
    });

    const {
      validationsOn,
      errorStatus,
      validations,
      fieldErrors,
      fieldValues,
      readOnlyValues,
      fieldErrorsMessage,
    } = state;

    /**
     * Form input field blur event handler
     *
     * @usage call fieldValidationCheck function
     * @usage Set the state of form errorStatus
     * @usage Enable or disable form submit button
     * @call onBlur event
     */
    const handleBlur = async (event, val, form) => {
      event.persist();
      const { name } = event.target;

      await fieldValidationCheck(name, val, form, event);

      if (name == "addressType") {
        // Check form validation because field validation updated
        multipleFieldsValidationCheck(
          [
            "companyName",
            "addressLine1",
            "addressLine2",
            "unitNo",
            "complexName",
            "streetNo",
            "streetName",
          ],
          form,
          event
        );
      }

      errorStatus[form] = await checkFormError(form);
      setState({
        ...state,
        errorStatus,
      });

      if (state.fieldErrors.fail) {
        continueDisable(true);
        let errMsg = fieldErrorsMessage[form][name];
        inlineAnalytics(errMsg);
      } else {
        if (selectedBillingAddress || isGuestUser) {
          checkErrorStatus();
        }
      }
    };

    /**
     * Form input field change event handler
     *
     * @usage call updateFieldValues function
     * @call onChange event
     */
    const handleChange = async (event, val, form) => {
      event.persist();

      if (!deliveryAnalytics && form == "delivery") {
        Analytics.link({
          ...Analytics.getUtagData([
            "page_name",
            "page_channel",
            "page_master_tab",
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
          ]),
          visitor_subscription_type:
            applicationType == "normal"
              ? analyticsData.visitor_subscription_type
              : "postpaid",
          page_form_event: "start",
          page_form_name: `checkout: delivery: ${customerStatus}: add delivery address`,
        });
        setDeliveryAnalytics(true);
      }

      if (!contactAnalytics && form == "details") {
        Analytics.link({
          ...Analytics.getUtagData([
            "page_name",
            "page_channel",
            "page_master_tab",
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
          ]),
          visitor_subscription_type:
            applicationType == "normal"
              ? analyticsData.visitor_subscription_type
              : "postpaid",
          page_form_event: "start",
          page_form_name: `checkout: delivery: ${customerStatus}: add contact details`,
        });
        setContactAnalytics(true);
      }

      await updateFieldValues(event, val, form);
    };

    /**
     * update input field values
     *
     * @usage Set the state of form validations, fieldValues
     */
    const updateFieldValues = async (event, val, form) => {
      const name = event.target.name;
      const value = val ? val : event.target.value;
      if (name == "addressType") {
        validations[form].companyName = false;
        validations[form].addressLine1 = false;
        validations[form].addressLine2 = false;
        validations[form].unitNo = false;
        validations[form].complexName = false;
        validations[form].streetNo = false;
        validations[form].streetName = true;

        if (value == POSTAL_ADDRESS_TYPE) {
          validations[form].streetName = false;
          validations[form].addressLine1 = true;
          validations[form].addressLine2 = true;

          if (
            fieldValues[form].addressLine1 == "" ||
            fieldValues[form].addressLine2 == ""
          ) {
            fieldErrors.fail = true;
          } else {
            fieldErrors.fail = false;
          }
        } else if (value == BUSINESS_ADDRESS_TYPE) {
          validations[form].companyName = true;
          validations[form].unitNo = true;
          validations[form].complexName = true;
          validations[form].streetNo = true;

          if (
            fieldValues[form].companyName == "" ||
            fieldValues[form].unitNo == "" ||
            fieldValues[form].complexName == "" ||
            fieldValues[form].streetNo == "" ||
            fieldValues[form].streetName == ""
          ) {
            fieldErrors.fail = true;
          } else {
            fieldErrors.fail = false;
          }
        } else if(value == RESIDENTIAL_ADDRESS_TYPE) {
          validations[form].unitNo = true;
          validations[form].complexName = true;
          validations[form].streetNo = true;
          validations[form].streetName = true;
        }

        if (
          fieldValues[form].unitNo == "" ||
          fieldValues[form].complexName == "" ||
          fieldValues[form].streetNo == "" ||
          fieldValues[form].streetName == ""
        ) {
          fieldErrors[form].fail = true;
        } else {
          fieldErrors[form].fail = false;
        }
      }

      if (
        name == "futureCheck" ||
        name == "contactCheck" ||
        name == "addressCheck" ||
        name == "informationCheck" ||
        name == "cifutureCheck" ||
        name == "ciaddressCheck"
      ) {
        fieldValues[form][name] = event.target.checked;

        if (name == "contactCheck") {
          if (event.target.checked) {
            validationsOn.contactDetails = false;
            errorStatus.contactDetails = false;
            setShowContactDetails(false);
          } else {
            validationsOn.contactDetails = true;
            errorStatus.contactDetails = await checkFormError("contactDetails");
            setShowContactDetails(true);
          }
          fieldErrors.fail = errorStatus.contactDetails;
        } else if (name == "addressCheck") {
          if (event.target.checked) {
            validationsOn.billing = false;
            errorStatus.billing = false;
            setShowBillingAddress(false);
          } else {
            validationsOn.billing = true;
            errorStatus.billing = await checkFormError("billing");
            setShowBillingAddress(true);
          }
          fieldErrors.fail = errorStatus.billing;
        } else if (name == "ciaddressCheck") {
          if (event.target.checked) {
            validationsOn.companyInformation = false;
            errorStatus.companyInformation = false;
          } else {
            validationsOn.companyInformation = true;
            errorStatus.companyInformation = await checkFormError(
              "companyInformation"
            );
          }
          fieldErrors.fail = errorStatus.companyInformation;
        }
      } else {
        fieldValues[form][name] = value;
      }

      if (
        name == "addressType" ||
        name == "province" ||
        name == "futureCheck"
      ) {
        let selectionName = name;
        switch (name) {
          case "addressType":
            selectionName = "address type";
            break;
          case "futureCheck":
            selectionName = "save address";
            break;
        }
        //capture analytics user selects addressType, province, futureCheck
        selectionAnalytics(selectionName, fieldValues[form][name]);
      }

      setState({
        ...state,
        validationsOn,
        validations,
        errorStatus,
        fieldErrors,
        fieldValues,
      });
    };

    const multipleFieldsValidationCheck = async (fieldsArray, form, event) => {
      var values = state.fieldValues[form];
      var errors = state.fieldErrors[form];
      var entries = fieldsArray.length;

      if (state.validationsOn[form]) {
        for (let i = 0; i < entries; i++) {
          if (values[fieldsArray[i]] !== "" || errors[fieldsArray[i]]) {
            fieldValidationCheck(
              fieldsArray[i],
              values[fieldsArray[i]],
              form,
              event
            );
          }
        }
      }
    };

    const fieldValidationCheck = async (name, val, form, event) => {
      const value = val ? val : event.target.value;

      switch (name) {
        case "addressName":
          if (
            state.validationsOn[form] &&
            state.validations[form].addressName
          ) {
            fieldErrors[form].addressName = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].addressName;
          } else {
            fieldErrors[form].addressName = false;
          }
          break;

        case "addressType":
          if (
            state.validationsOn[form] &&
            state.validations[form].addressType
          ) {
            fieldErrors[form].addressType = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].addressType;
          } else {
            fieldErrors.addressType = false;
          }
          break;

        case "companyName":
          if (
            state.validationsOn[form] &&
            state.validations[form].companyName
          ) {
            fieldErrors[form].companyName = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].companyName;
          } else {
            fieldErrors[form].companyName = false;
          }
          break;

        case "companyVatName":
          if (
            state.validationsOn[form] &&
            state.validations[form].companyVatName
          ) {
            fieldErrors[form].companyVatName = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].companyVatName;
          } else {
            fieldErrors[form].companyVatName = false;
          }
          break;

        case "companyVatNumber":
          if (
            state.validationsOn[form] &&
            state.validations[form].companyVatNumber
          ) {
            fieldErrors[form].companyVatNumber =
              value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].companyVatNumber;
          } else {
            fieldErrors[form].companyVatNumber = false;
          }
          break;

        case "addressLine1":
          if (
            state.validationsOn[form] &&
            state.validations[form].addressLine1
          ) {
            fieldErrors[form].addressLine1 = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].addressLine1;
          } else {
            fieldErrors[form].addressLine1 = false;
          }
          break;

        case "addressLine2":
          if (
            state.validationsOn[form] &&
            state.validations[form].addressLine2
          ) {
            fieldErrors[form].addressLine2 = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].addressLine2;
          } else {
            fieldErrors[form].addressLine2 = false;
          }
          break;

        case "unitNo":
          if (value.length > 0) {
            fieldErrors[form].unitNo = numRegEx.test(value) ? false : true;
            if (fieldErrors[form].unitNo) {
              if (
                state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE
              ) {
                fieldErrorsMessage[form].unitNo =
                  errorMessages.checkout[form].floorNo.onlyNumber;
              } else {
                fieldErrorsMessage[form].unitNo =
                  errorMessages.checkout[form].unitNo.onlyNumber;
              }
            }
          } else {
            if (state.validationsOn[form] && state.validations[form].unitNo) {
              fieldErrors[form].unitNo = true;
            } else {
              fieldErrors[form].unitNo = false;
            }

            if (state.fieldValues[form].addressType == BUSINESS_ADDRESS_TYPE) {
              fieldErrorsMessage[form].unitNo =
                errorMessages.checkout.errors.addressForm[form].floorNo;
            } else {
              fieldErrorsMessage[form].unitNo =
                errorMessages.checkout.errors.addressForm[form].unitNo;
            }
          }
          fieldErrors.fail = fieldErrors[form].unitNo;
          break;

        case "complexName":
          if (
            state.validationsOn[form] &&
            state.validations[form].complexName
          ) {
            fieldErrors[form].complexName = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].complexName;
            if (state.fieldValues.addressType == BUSINESS_ADDRESS_TYPE) {
              fieldErrorsMessage[form].complexName =
                state.fieldErrorsMessage[form].officeComplexName;
            } else {
              fieldErrorsMessage[form].complexName =
                state.fieldErrorsMessage[form].complexName;
            }
          } else {
            fieldErrors[form].complexName = false;
          }

          if(state.fieldValues[form].complexName !=="") {
            state.validations.delivery.unitNo = true;
            state.fieldErrors.delivery.unitNo = true;
          }
          if(state.fieldValues[form].complexName == "") {
            state.validations.delivery.unitNo = false;
            state.fieldErrors.delivery.unitNo = false;
          }
          break;

        case "streetNo":
          if (value.length > 0) {
            fieldErrors[form].streetNo = numRegEx.test(value) ? false : true;
            if (fieldErrors[form].streetNo) {
              fieldErrorsMessage[form].streetNo =
                errorMessages.checkout[form].streetNo.onlyValid;
            }
          } else {
            if (state.validationsOn[form] && state.validations[form].streetNo) {
              fieldErrors[form].streetNo = true;
            } else {
              fieldErrors[form].streetNo = false;
            }

            fieldErrorsMessage[form].streetNo =
              errorMessages.checkout.errors.addressForm[form].streetNo;
          }
          fieldErrors.fail = fieldErrors[form].streetNo;
          break;

        case "streetName":
          if (state.validationsOn[form] && state.validations[form].streetName) {
            if (value.length > 0) {
              if (!streetNameRegEx.test(value)) {
                fieldErrors[form].streetName = true;
                fieldErrorsMessage[form].streetName =
                  errorMessages.checkout[form].streetName.onlyValid;
              } else {
                fieldErrors[form].streetName = false;
              }
            } else {
              fieldErrors[form].streetName = true;
              fieldErrorsMessage[form].streetName =
                errorMessages.checkout.errors.addressForm[form].streetName;
            }
            fieldErrors.fail = fieldErrors[form].streetName;
          } else {
            fieldErrors[form].streetName = false;
          }
          break;

        case "suburb":
          if (state.validationsOn[form] && state.validations[form].suburb) {
            fieldErrors[form].suburb = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].suburb;
          } else {
            fieldErrors[form].suburb = false;
          }
          break;

        case "town":
          if (state.validationsOn[form] && state.validations[form].town) {
            fieldErrors[form].town = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].town;
          } else {
            fieldErrors[form].town = false;
          }
          break;

        case "postalCode":
          if (state.validationsOn[form] && state.validations[form].postalCode) {
            if (value.length > 0) {
              if (!numRegEx.test(value)) {
                fieldErrors[form].postalCode = true;
                fieldErrorsMessage[form].postalCode =
                  errorMessages.checkout[form].postalCode.onlyNumber;
              } else if (value.length < 4) {
                fieldErrors[form].postalCode = true;
                fieldErrorsMessage[form].postalCode =
                  errorMessages.checkout[form].postalCode.onlyValid;
              } else {
                fieldErrors[form].postalCode = false;
              }
            } else {
              fieldErrors[form].postalCode = true;
              fieldErrorsMessage[form].postalCode =
                errorMessages.checkout.errors.addressForm[form].postalCode;
            }
            fieldErrors.fail = fieldErrors[form].postalCode;
          } else {
            fieldErrors[form].postalCode = false;
          }
          break;

        case "province":
          if (state.validationsOn[form] && state.validations[form].province) {
            fieldErrors[form].province = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].province;
          } else {
            fieldErrors[form].province = false;
          }
          break;

        case "firstName":
          if (state.validationsOn[form] && state.validations[form].firstName) {
            if (value.length > 0) {
              if (value.length <= 2) {
                fieldErrors[form].firstName = true;
                fieldErrorsMessage[form].firstName =
                  errorMessages.checkout[form].firstName.minCharacters;
              } else {
                fieldErrors[form].firstName = false;
              }
            } else {
              fieldErrors[form].firstName = true;
              fieldErrorsMessage[form].firstName =
                errorMessages.checkout.errors.addressForm[form].firstName;
            }
            fieldErrors.fail = fieldErrors[form].firstName;
          } else {
            fieldErrors[form].firstName = false;
          }
          break;

        case "surName":
          if (state.validationsOn[form] && state.validations[form].surName) {
            if (value.length > 0) {
              if (value.length <= 2) {
                fieldErrors[form].surName = true;
                fieldErrorsMessage[form].surName =
                  errorMessages.checkout[form].surName.minCharacters;
              } else {
                fieldErrors[form].surName = false;
              }
            } else {
              fieldErrors[form].surName = true;
              fieldErrorsMessage[form].surName =
                errorMessages.checkout.errors.addressForm[form].surName;
            }
            fieldErrors.fail = fieldErrors[form].surName;
          } else {
            fieldErrors[form].surName = false;
          }
          break;

        case "cellNumber":
          if (state.validationsOn[form] && state.validations[form].cellNumber) {
            if (value.length > 0) {
              if (!numRegEx.test(value)) {
                fieldErrors[form].cellNumber = true;
                fieldErrorsMessage[form].cellNumber =
                  errorMessages.checkout[form].cellNumber.onlyNumber;
              } else if (!cellPhoneRegEx.test(value)) {
                fieldErrors[form].cellNumber = true;
                fieldErrorsMessage[form].cellNumber =
                  errorMessages.checkout[form].cellNumber.startWith;
              } else if (africaCountryCode(value) && value.length < 11) {
                fieldErrors[form].cellNumber = true;
                fieldErrorsMessage[form].cellNumber =
                  errorMessages.checkout.errors.addressForm[form].cellNumber;
              } else if (value.length < 10) {
                fieldErrors[form].cellNumber = true;
                fieldErrorsMessage[form].cellNumber =
                  errorMessages.checkout.errors.addressForm[form].cellNumber;
              } else {
                fieldErrors[form].cellNumber = false;
              }
            } else {
              fieldErrors[form].cellNumber = true;
              fieldErrorsMessage[form].cellNumber =
                errorMessages.checkout.errors.addressForm[form].cellNumber;
            }
            fieldErrors.fail = fieldErrors[form].cellNumber;
          } else {
            fieldErrors[form].cellNumber = false;
          }
          break;

        case "email":
          if (state.validationsOn[form] && state.validations[form].email) {
            if (value.length > 0) {
              fieldErrors[form].email = emailRegEx.test(value) ? false : true;
              if (fieldErrors[form].email) {
                fieldErrorsMessage.email =
                  errorMessages.checkout[form].email.onlyValid;
              }
            } else {
              fieldErrors[form].email = true;
              fieldErrorsMessage[form].email =
                errorMessages.checkout.errors.addressForm[form].email;
            }
            fieldErrors.fail = fieldErrors[form].email;
          } else {
            fieldErrors[form].email = false;
          }
          break;

        case "instructions":
          if (
            state.validationsOn[form] &&
            state.validations[form].instructions
          ) {
            fieldErrors[form].instructions = value.length == 0 ? true : false;
            fieldErrors.fail = fieldErrors[form].instructions;
          } else {
            fieldErrors[form].instructions = false;
          }
          break;
      }

      setState({
        ...state,
        fieldErrors,
        fieldErrorsMessage,
      });
    };

    /**
     * Set the analytics(link)
     *
     * @call when there is any form field error occured
     */
    const inlineAnalytics = (message) => {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
        ]),
        visitor_subscription_type:
          applicationType == "normal"
            ? analyticsData.visitor_subscription_type
            : "postpaid",
        page_form_event: "error",
        page_errors: message,
        page_form_name: `checkout: delivery: ${customerStatus}: form`,
        page_error_type: "form",
      });
    };

    /**
     * Set the selection analytics(link)
     *
     * @call when dropdown value change
     */
    const selectionAnalytics = (selectionType, value) => {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
        ]),
        visitor_subscription_type:
          applicationType == "normal"
            ? analyticsData.visitor_subscription_type
            : "postpaid",
        page_tool_event: "use",
        page_tool_name: `checkout: delivery: ${customerStatus}: ${selectionType}`,
        filter_query: value,
      });
    };

    function checkFormError(form) {
      var values = state.fieldValues[form];
      var errors = state.fieldErrors[form];
      var entries = Object.entries(state.validations[form]);

      if (state.validationsOn[form]) {
        for (const [key, value] of entries) {
          if ((values[key] == "" && value) || errors[key]) {
            return true;
          }
        }
        return false;
      } else {
        return false;
      }
    }

    function checkErrorStatus() {
      var errValues = Object.values(state.errorStatus);

      for (const err of errValues) {
        if (err) {
          continueDisable(true);
          return;
        }
      }

      if (totalDeliveryAddress !== 0) {
        if (selectedDeliveryAddress) {
          continueDisable(false);
        } else {
          continueDisable(true);
        }
      } else {
        continueDisable(false);
      }
    }

    const addressSearchResultMap = async () => {
      const localityType = finalAddress.address_components;
      if (localityType && localityType.length > 0) {
        await mapAddressSearchData(localityType);

        errorStatus["delivery"] = await checkFormError("delivery");
        setState({
          ...state,
          errorStatus,
        });

        if (errorStatus["delivery"]) {
          continueDisable(true);
        } else {
          if (selectedBillingAddress || isGuestUser) {
            checkErrorStatus();
          }
        }
      }
    };

    const mapAddressSearchData = async (localityType) => {
      readOnlyValues.delivery.postalCode = false;

      fieldValues.delivery.unitNo = "";
      fieldValues.delivery.complexName = "";
      fieldValues.delivery.streetNo = "";
      fieldValues.delivery.streetName = "";
      fieldValues.delivery.suburb = "";
      fieldValues.delivery.province = "";
      fieldValues.delivery.town = "";
      fieldValues.delivery.postalCode = "";

      fieldErrors.delivery.unitNo = false;
      fieldErrors.delivery.complexName = false;
      fieldErrors.delivery.streetNo = false;
      fieldErrors.delivery.streetName = false;
      fieldErrors.delivery.suburb = false;
      fieldErrors.delivery.province = false;
      fieldErrors.delivery.town = false;
      fieldErrors.delivery.postalCode = false;

      for (let i = 0; i < localityType.length; i++) {
        if (localityType[i].administrative_type == "unit") {
          if (localityType[i].long_name) {
            fieldValues.delivery.unitNo = localityType[i].long_name;
          }
        }

        if (localityType[i].administrative_type == "building") {
          fieldValues.delivery.complexName = localityType[i].long_name;
        }

        if (localityType[i].administrative_type == "street_number") {
          fieldValues.delivery.streetNo = localityType[i].long_name;
        }

        if (localityType[i].administrative_type == "route") {
          fieldValues.delivery.streetName = localityType[i].long_name;
        }

        if (localityType[i].administrative_type == "suburb") {
          fieldValues.delivery.suburb = localityType[i].long_name;
        }

        if (localityType[i].administrative_type == "province") {
          fieldValues.delivery.province = getProvinceValue(
            localityType[i].long_name
          );
        }

        if (
          localityType[i].administrative_type == "town" ||
          localityType[i].administrative_type == "city"
        ) {
          fieldValues.delivery.town = localityType[i].long_name;
        }

        if (localityType[i].administrative_type == "post_street") {
          if (localityType[i].long_name.length > 0) {
            readOnlyValues.delivery.postalCode = true;
          }
          fieldValues.delivery.postalCode = localityType[i].long_name;
        }
      }

      setState({
        ...state,
        readOnlyValues,
        fieldValues,
        fieldErrors,
      });
    };

    const mapContactFormData = () => {
      let contactData = { firstName: "", surName: "", cellNumber: "" };

      if (isGuestUser) {
        contactData.firstName = state.fieldValues["delivery"].contactCheck
          ? state.fieldValues["details"].firstName
          : state.fieldValues["contactDetails"].firstName;
        contactData.surName = state.fieldValues["delivery"].contactCheck
          ? state.fieldValues["details"].surName
          : state.fieldValues["contactDetails"].surName;
        contactData.cellNumber = state.fieldValues["delivery"].contactCheck
          ? state.fieldValues["details"].cellNumber
          : state.fieldValues["contactDetails"].cellNumber;
      } else {
        contactData.firstName = state.fieldValues["details"].contactCheck
          ? state.fieldValues["details"].firstName
          : state.fieldValues["contactDetails"].firstName;
        contactData.surName = state.fieldValues["details"].contactCheck
          ? state.fieldValues["details"].surName
          : state.fieldValues["contactDetails"].surName;
        contactData.cellNumber = state.fieldValues["details"].contactCheck
          ? state.fieldValues["details"].cellNumber
          : state.fieldValues["contactDetails"].cellNumber;
      }

      return contactData;
    };

    const handleSelected = (value) => {
      setSelected(value);
      let sortedSearchList;
      if (value === "Distance") {
        sortedSearchList = storeListsFromSearch.sort(function (a, b) {
          if (a.distance < b.distance) {
            return -1;
          }
          if (a.distance > b.distance) {
            return 1;
          }
          return 0;
        });
      } else if (value === "Alphabetical (A-Z)") {
        sortedSearchList = storeListsFromSearch.sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      } else {
        sortedSearchList = storeListsFromSearch.sort(function (a, b) {
          if (a.name > b.name) {
            return -1;
          }
          if (a.name < b.name) {
            return 1;
          }
          return 0;
        });
      }
      const pageName = Analytics.getUtagData(["page_name"]).page_name;
      Analytics.link({
        link_type: "o",
        page_tool_event: "use",
        page_tool_name: `${pageName}: sort filter`,
        filter_query: value,
      });
      //setSelectedSearchFromStore(sortedSearchList);
    };

    const mapDeliveryFieldData = () => {
      let regionValue = getRegionValue(state.fieldValues["delivery"].province);
      let contactFormData = mapContactFormData();

      return {
        cart_id: cartId !== "" ? cartId : null,
        region: regionValue && regionValue.code ? regionValue.code : null,
        country_code: countryCode ? countryCode : null,
        instructions:
          state.fieldValues["delivery"].instructions !== ""
            ? state.fieldValues["delivery"].instructions
            : null,
        street:
          state.fieldValues["delivery"].streetName !== "" &&
          state.validations["delivery"].streetName
            ? seperateStreetString(state.fieldValues["delivery"].streetName)
            : state.fieldValues["delivery"].addressLine1 !== "" &&
              state.fieldValues["delivery"].addressLine2 !== "" &&
              state.validations["delivery"].addressLine1 &&
              state.validations["delivery"].addressLine2
            ? createStreetFromAddressLines(
                state.fieldValues["delivery"].addressLine1,
                state.fieldValues["delivery"].addressLine2
              )
            : null,
        postcode:
          state.fieldValues["delivery"].postalCode !== ""
            ? state.fieldValues["delivery"].postalCode
            : null,
        city:
          state.fieldValues["delivery"].town !== ""
            ? state.fieldValues["delivery"].town
            : null,
        address_type_name:
          state.fieldValues["delivery"].addressType !== ""
            ? state.fieldValues["delivery"].addressType
            : null,
        address_name:
          state.fieldValues["delivery"].addressName !== ""
            ? state.fieldValues["delivery"].addressName
            : null,
        company:
          state.fieldValues["delivery"].companyName !== ""
            ? state.fieldValues["delivery"].companyName
            : null,
        unit_number:
          state.fieldValues["delivery"].unitNo !== ""
            ? state.fieldValues["delivery"].unitNo
            : null,
        complex_name:
          state.fieldValues["delivery"].complexName !== ""
            ? state.fieldValues["delivery"].complexName
            : null,
        street_number:
          state.fieldValues["delivery"].streetNo !== ""
            ? state.fieldValues["delivery"].streetNo
            : null,
        suburb:
          state.fieldValues["delivery"].suburb !== ""
            ? state.fieldValues["delivery"].suburb
            : null,
        firstname: contactFormData.firstName,
        lastname: contactFormData.surName,
        telephone: contactFormData.cellNumber,
        save_in_address_book: isGuestUser
          ? false
          : state.fieldValues["delivery"].futureCheck,
        default_shipping: false,
        default_billing: false,
        is_shipping_address: 0,
        is_billing_address: 0,
      };
    };

    const mapBillingFieldData = () => {
      let regionValue = getRegionValue(state.fieldValues["billing"].province);
      let contactFormData = mapContactFormData();

      return {
        cart_id: cartId !== "" ? cartId : null,
        region: regionValue && regionValue.code ? regionValue.code : null,
        country_code: countryCode ? countryCode : null,
        instructions:
          state.fieldValues["billing"].instructions !== ""
            ? state.fieldValues["billing"].instructions
            : null,
        street:
          state.fieldValues["billing"].streetName !== "" &&
          state.validations["billing"].streetName
            ? seperateStreetString(state.fieldValues["billing"].streetName)
            : state.fieldValues["billing"].addressLine1 !== "" &&
              state.fieldValues["billing"].addressLine2 !== "" &&
              state.validations["billing"].addressLine1 &&
              state.validations["billing"].addressLine2
            ? createStreetFromAddressLines(
                state.fieldValues["billing"].addressLine1,
                state.fieldValues["billing"].addressLine2
              )
            : null,
        postcode:
          state.fieldValues["billing"].postalCode !== ""
            ? state.fieldValues["billing"].postalCode
            : null,
        city:
          state.fieldValues["billing"].town !== ""
            ? state.fieldValues["billing"].town
            : null,
        address_type_name:
          state.fieldValues["billing"].addressType !== ""
            ? state.fieldValues["billing"].addressType
            : null,
        address_name:
          state.fieldValues["billing"].addressName !== ""
            ? state.fieldValues["billing"].addressName
            : null,
        company:
          state.fieldValues["billing"].companyName !== ""
            ? state.fieldValues["billing"].companyName
            : null,
        unit_number:
          state.fieldValues["billing"].unitNo !== ""
            ? state.fieldValues["billing"].unitNo
            : null,
        complex_name:
          state.fieldValues["billing"].complexName !== ""
            ? state.fieldValues["billing"].complexName
            : null,
        street_number:
          state.fieldValues["billing"].streetNo !== ""
            ? state.fieldValues["billing"].streetNo
            : null,
        suburb:
          state.fieldValues["billing"].suburb !== ""
            ? state.fieldValues["billing"].suburb
            : null,
        firstname: contactFormData.firstName,
        lastname: contactFormData.surName,
        telephone: contactFormData.cellNumber,
        save_in_address_book: isGuestUser ? false : true,
        default_shipping: false,
        default_billing: false,
        is_shipping_address: 0,
        is_billing_address: 0,
      };
    };

    const mapProfileFieldData = () => {
      return {
        didData: {
          profileId:
            profileData && profileData.profileID ? profileData.profileID : null,
          firstName:
            state.fieldValues["details"].firstName !== ""
              ? state.fieldValues["details"].firstName
              : null,
          lastName:
            state.fieldValues["details"].surName !== ""
              ? state.fieldValues["details"].surName
              : null,
          telephone:
            state.fieldValues["details"].cellNumber !== ""
              ? state.fieldValues["details"].cellNumber
              : null,
          emailID:
            state.fieldValues["details"].email !== ""
              ? state.fieldValues["details"].email
              : null,
          dob: profileData && profileData.dob ? profileData.dob : null,
          gender: profileData && profileData.gender ? profileData.gender : null,
        },
      };
    };

    const profileUpdate = async () => {
      var inputProfileData = mapProfileFieldData();

      try {
        showSpinner();
        let results = await updateProfileDataService(inputProfileData);

        if (!results.fail) {
          if (applicationType == "normal") {
            addDeliveryAddress();
          } else {
            addDeliveryAddress();
          }
        } else {
          hideSpinner();
          if (results && results.errors) {
            technicalFailure(results.errors?.[0]?.message);
          } else {
            technicalFailure();
          }
        }
      } catch {
        hideSpinner();
        technicalFailure();
      }
    };

    const addEmailAddress = async () => {
      let cart_id = cartId !== "" ? cartId : null;
      let email =
        state.fieldValues["details"].email !== ""
          ? state.fieldValues["details"].email
          : null;

      try {
        showSpinner();
        let results = await setGuestEmailOnCartService(cart_id, email);

        if (!results.fail) {
          addDeliveryAddress();
        } else {
          hideSpinner();
          if (results && results.errors) {
            technicalFailure(results.errors?.[0]?.message);
          } else {
            technicalFailure();
          }
        }
      } catch {
        hideSpinner();
        technicalFailure();
      }
    };

    const addDeliveryAddress = async () => {
      var inputAddressObj =
        selectedReceiveType == "courier"
          ? mapDeliveryFieldData()
          : mapDeliveryOnStoreFieldData();

      if (totalDeliveryAddress == 0 || selectedReceiveType != "courier") {
        inputAddressObj.is_shipping_address = 1;
        try {
          showSpinner();

          let results = await setNewShippingAddressService(inputAddressObj);

          if (!results.fail) {
            dispatch({
              type: SET_SHIPPING,
              payload: results,
            });

            addShippingMethod();
            addBillingAddress();

            Analytics.link({
              ...Analytics.getUtagData([
                "page_name",
                "page_channel",
                "page_master_tab",
                "visitor_login_status",
                "visitor_customer_id",
                "visitor_id_hash",
                "visitor_msisdn_hash",
              ]),
              visitor_subscription_type:
                applicationType == "normal"
                  ? analyticsData.visitor_subscription_type
                  : "postpaid",
              page_form_event: "success",
              page_form_name: `checkout: delivery: ${customerStatus}: add delivery address`,
            });
          } else {
            hideSpinner();
            if (results && results.errors) {
              technicalFailure(results.errors?.[0]?.message);
            } else {
              technicalFailure();
            }
          }
        } catch {
          hideSpinner();
          technicalFailure();
        }
      } else {
        try {
          showSpinner();
          let results = await setExistingShippingAddressService(
            cartId,
            selectedDeliveryAddress
          );

          if (!results.fail) {
            dispatch({
              type: SET_SHIPPING,
              payload: results,
            });
            addShippingMethod();
            addBillingAddress();
          } else {
            hideSpinner();
            if (results && results.errors) {
              technicalFailure(results.errors?.[0]?.message);
            } else {
              technicalFailure();
            }
          }
        } catch {
          hideSpinner();
          technicalFailure();
        }
      }
    };

    const addShippingMethod = async () => {
      let cart_id = cartId !== "" ? cartId : null;
      let carrierCode =
        selectedReceiveType == "store" ? "clickandcollect" : cartDetails?.shippingFeeCalculate?.carrier_code;
      let methodCode =
        selectedReceiveType == "store" ? "clickandcollect" : cartDetails?.shippingFeeCalculate?.method_code;
      let results, retryCounter = 0;

      if (currentJourneyType == journeyType.upgrade) {
        carrierCode = "flatrate";
        methodCode = "flatrate";
      }
      do {
        results = await setShippingMethodsOnCartService(
          cart_id,
          carrierCode,
          methodCode
        );
        retryCounter += 1;
      }
      while ((results?.shippingMethod?.cart?.shipping_addresses[0]?.selected_shipping_method === null || results?.errors) && retryCounter < 3);

      if (!results.fail) {
        dispatch({ type: SET_SHIPPING_METHOD, payload: results });
      }
    };

    const addBillingAddress = async () => {
      var inputAddressObj;
      if (isGuestUser && !state.fieldValues["billing"].addressCheck) {
        inputAddressObj = mapBillingFieldData();
      } else {
        inputAddressObj =
          selectedReceiveType == "courier"
            ? mapDeliveryFieldData()
            : mapDeliveryOnStoreFieldData();
      }

      if (
        (totalDeliveryAddress == 0 &&
          (selectedBillingAddress == true || isGuestUser)) ||
        selectedReceiveType == "store"
      ) {
        if (applicationType == "normal") {
          inputAddressObj.is_billing_address = 1;
        } else {
          inputAddressObj.is_shipping_address = 1;
          inputAddressObj.is_billing_address = 1;
          inputAddressObj.same_as_shipping = true;
        }

        try {
          showSpinner();
          let results = await setNewBillingAddressService(inputAddressObj);

          if (!results.fail) {
            hideSpinner();

            if (applicationType !== "normal") {
              //set shipping address as well for postpaid journey
              dispatch({
                type: SET_SHIPPING,
                payload: results,
              });
            }

            dispatch({
              type: SET_BILLING,
              payload: results,
            });
            Analytics.link({
              ...Analytics.getUtagData([
                "page_name",
                "page_channel",
                "page_master_tab",
                "visitor_login_status",
                "visitor_customer_id",
                "visitor_id_hash",
                "visitor_msisdn_hash",
              ]),
              visitor_subscription_type:
                applicationType == "normal"
                  ? analyticsData.visitor_subscription_type
                  : "postpaid",
              page_form_event: "success",
              page_form_name:
                applicationType == "normal"
                  ? `checkout: delivery: ${customerStatus}: add billing address`
                  : `checkout: delivery: ${customerStatus}: add delivery address`,
            });
            //navigate to review order
            navigate("review");
          } else {
            hideSpinner();
            if (results && results.errors) {
              technicalFailure(results.errors?.[0]?.message);
            } else {
              technicalFailure();
            }
          }
        } catch {
          hideSpinner();
          technicalFailure();
        }
      } else {
        try {
          showSpinner();
          let results = await setExistingBillAddressService(
            cartId,
            selectedBillingAddress == true
              ? selectedDeliveryAddress
              : selectedBillingAddress,
            applicationType == "normal" ? false : true
          );

          if (!results.fail) {
            hideSpinner();

            if (applicationType !== "normal") {
              //set shipping address as well for postpaid journey
              dispatch({
                type: SET_SHIPPING,
                payload: results,
              });
            }

            dispatch({
              type: SET_BILLING,
              payload: results,
            });
            Analytics.link({
              ...Analytics.getUtagData([
                "page_name",
                "page_channel",
                "page_master_tab",
                "visitor_login_status",
                "visitor_customer_id",
                "visitor_id_hash",
                "visitor_msisdn_hash",
              ]),
              visitor_subscription_type:
                applicationType == "normal"
                  ? analyticsData.visitor_subscription_type
                  : "postpaid",
              page_form_event: "success",
              page_form_name:
                applicationType == "normal"
                  ? `checkout: delivery: ${customerStatus}: add billing address`
                  : `checkout: delivery: ${customerStatus}: add delivery address`,
            });
            //navigate to review order
            navigate("review");
          } else {
            hideSpinner();
            if (results && results.errors) {
              technicalFailure(results.errors?.[0]?.message);
            } else {
              technicalFailure();
            }
          }
        } catch {
          hideSpinner();
          technicalFailure();
        }
      }
    };

    const technicalFailure = (errorMsg) => {
      if (matchWordInString(errorMsg, "authorized")) {
        displaySnackBar(labels.checkout.lbl_session_invalid);
        setReLogin(true);
      } else if (matchWordInString(errorMsg, "cart")) {
        displaySnackBar(labels.checkout.lbl_cart_invalid);
        setReLogin(true);
      } else if (matchWordInString(errorMsg, "server")) {
        if (submitAttempt == 0) {
          displaySnackBar(labels.checkout.lbl_something_went_wrong_try_again);
        } else {
          fetchErrorDetails(`checkoutAPI_invalid`);
          closeSnackBar();
        }
        setSubmitAttempt(submitAttempt + 1);
      } else {
        displaySnackBar(labels.checkout.lbl_something_went_wrong_try_again);
      }
    };

    /**
     * Get the error display data
     * @usage Redirect to checkout error with error details
     */
    const fetchErrorDetails = async (resultCode) => {
      const pageName = `checkout: delivery: ${customerStatus}`;

      try {
        showSpinner();
        const result = await ajaxService.httpGet(
          "drupalBaseUrl",
          "",
          "api",
          "errorResultDetails",
          [resultCode]
        );

        setPageErr({
          type: "error",
          title: result[0].resultTitle,
          desc:
            result[0].resultText && result[0].resultText !== ""
              ? result[0].resultText
              : result[0].resultHTML,
          primaryLabel:
            result[0].primaryEnabled === "Yes"
              ? result[0].primaryCTAText
              : null,
          primaryUrl:
            result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
          secondaryLabel:
            result[0].secondaryEnabled === "Yes"
              ? result[0].secondaryCTAText
              : null,
          secondaryUrl:
            result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
          handlePrimaryClick: () =>
            handlePrimaryClick(
              generateFormURL(
                result[0].primaryCTAURL,
                result[0].leadType,
                result[0].primaryCTAType
              ),
              result[0].primaryCTAText
            ),
          handleSecondaryClick: () =>
            handleSecondaryClick(
              generateFormURL(
                result[0].secondaryCTAURL,
                result[0].leadType,
                result[0].secondaryCTAType
              ),
              result[0].secondaryCTAText
            ),
          imgUrl: result[0].icon,
          pageName: pageName,
        });
        hideSpinner();
        //navigate to checkout page error
        navigate("pageError");
      } catch {
        setPageErr({
          type: "error",
          title: labels.checkout.lbl_invalid_attempt_title,
          desc: labels.checkout.lbl_invalid_attempt_desc,
          primaryLabel: "Call me back",
          secondaryLabel: "Exit checkout",
          handlePrimaryClick: () => handlePrimaryClick(null, "call me back"),
          handleSecondaryClick: () =>
            handleSecondaryClick(null, "exit checkout"),
          imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
          pageName: pageName,
        });
        hideSpinner();
        //navigate to checkout page error
        navigate("pageError");
      }
    };

    const handlePrimaryClick = (url, label) => {
      showSpinner();
      const pageName = Analytics.getUtagData(["page_name"]).page_name;
      Analytics.link({
        link_type: "o",
        link_name: `${pageName}: ${label}`,
        page_name: `${pageName}`,
      });

      if (url) {
        router.push(`${urlPrefix}${url}`).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`${urlPrefix}/forms/ecommerce`).then(() => {
          hideSpinner();
        });
      }
    };

    const handleSecondaryClick = (url, label) => {
      showSpinner();
      const pageName = Analytics.getUtagData(["page_name"]).page_name;
      Analytics.link({
        link_type: "o",
        link_name: `${pageName}: ${label}`,
        page_name: `${pageName}`,
      });

      if (url) {
        router.push(`${urlPrefix}${url}`).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`${urlPrefix}/cart`).then(() => {
          hideSpinner();
        });
      }
    };

    const displaySnackBar = (message, level = "page_level") => {
      setShowSnackBar({ visible: true, message: message });

      const pageAnalyticsData = {
        page_errors: message,
        page_error_type: "page",
      };

      if (level == "form_level") {
        pageAnalyticsData.page_form_event = "error";
        pageAnalyticsData.page_form_name = `checkout: delivery: ${customerStatus}: form`;
        pageAnalyticsData.page_error_type = "form";
      }

      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
        ]),
        visitor_subscription_type:
          applicationType == "normal"
            ? analyticsData.visitor_subscription_type
            : "postpaid",
        ...pageAnalyticsData,
      });
    };

    const closeSnackBar = () => {
      setShowSnackBar({ visible: false, message: "" });
    };

    const showModal = (popUpType, variant, addressData) => {
      if (variant == "add") {
        addressData.firstName = state.fieldValues["details"].firstName;
        addressData.surName = state.fieldValues["details"].surName;
        addressData.cellNumber = state.fieldValues["details"].cellNumber;
      }

      setModalType(popUpType);
      setModalVariant(variant);
      setModalValues(addressData);
      setModalShow(true);

      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
        ]),
        visitor_subscription_type:
          applicationType == "normal"
            ? analyticsData.visitor_subscription_type
            : "postpaid",
        page_form_event: "start",
        page_form_name: `checkout: ${popUpType}: ${customerStatus}: ${variant} ${popUpType} address`,
      });
    };

    const hideModal = (refresh) => {
      setModalShow(false);

      if (refresh == true) {
        fetchData();
      }
    };

    const displyConfirmModal = (addressData, popUpType) => {
      var nameHTML =
        '<div class="' +
        styles["value"] +
        '"><span class="' +
        styles["value__first"] +
        '">' +
        addressData.name +
        "</span>";

      var streetHTML = "";

      if (addressData.street && addressData.suburb && addressData.postcode) {
        streetHTML =
          '<span class="' +
          styles["value__second"] +
          '">' +
          addressData.street +
          ", " +
          addressData.suburb +
          ", " +
          addressData.postcode +
          "</span>";
      } else if (addressData.suburb && addressData.postcode) {
        streetHTML =
          '<span class="' +
          styles["value__second"] +
          '">' +
          addressData.suburb +
          ", " +
          addressData.postcode +
          "</span>";
      }

      var closeHTML = "</div>";

      var contentHTML =
        streetHTML !== ""
          ? nameHTML + streetHTML + closeHTML
          : nameHTML + closeHTML;

      setConfirmModalContent(contentHTML);
      setDeleteId(addressData.id);
      setDeleteType(popUpType);
      setShowConfirmModal(true);

      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "page_channel",
          "page_master_tab",
          "visitor_login_status",
          "visitor_customer_id",
          "visitor_id_hash",
          "visitor_msisdn_hash",
        ]),
        visitor_subscription_type:
          applicationType == "normal"
            ? analyticsData.visitor_subscription_type
            : "postpaid",
        page_form_event: "start",
        page_form_name: `checkout: ${popUpType}: ${customerStatus}: delete ${popUpType} address`,
      });
    };

    const cancelConfirmModel = () => {
      setShowConfirmModal(false);
    };

    const approveConfirmModel = async () => {
      setShowConfirmModal(false);

      try {
        showSpinner();
        let results = await deleteCustomerAddressService(deleteId);

        if (!results.fail) {
          setSelectedDeliveryAddress(false);
          setSelectedBillingAddress(true);
          fetchData();

          Analytics.link({
            ...Analytics.getUtagData([
              "page_name",
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
            ]),
            visitor_subscription_type:
              applicationType == "normal"
                ? analyticsData.visitor_subscription_type
                : "postpaid",
            page_form_event: "success",
            page_form_name: `checkout: delivery: ${customerStatus}: delete ${deleteType} address`,
          });
        } else {
          hideSpinner();
          if (results && results.errors) {
            technicalFailure(results.errors?.[0]?.message);
          } else {
            technicalFailure();
          }
        }
      } catch {
        hideSpinner();
        technicalFailure();
      }
    };

    const addressTileClickHandler = (data, type) => {
      if (type == "delivery") {
        setSelectedDeliveryAddress(data.id);

        Analytics.link({
          ...Analytics.getUtagData([
            "page_name",
            "page_channel",
            "page_master_tab",
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
          ]),
          visitor_subscription_type:
            applicationType == "normal"
              ? analyticsData.visitor_subscription_type
              : "postpaid",
          page_tool_event: "use",
          page_tool_name: `checkout: delivery: ${customerStatus}: select delivery address`,
          filter_query: data.address_name,
        });
      } else {
        setSelectedBillingAddress(data.id);

        Analytics.link({
          ...Analytics.getUtagData([
            "page_name",
            "page_channel",
            "page_master_tab",
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
          ]),
          visitor_subscription_type:
            applicationType == "normal"
              ? analyticsData.visitor_subscription_type
              : "postpaid",
          page_tool_event: "use",
          page_tool_name: `checkout: delivery: ${customerStatus}: select billing address`,
          filter_query: data.address_name,
        });
      }
    };

    const refreshState = () => {
      errorStatus.delivery = isGuestUser ? true : false;
      errorStatus.details = isGuestUser ? true : false;

      setState({
        ...state,
        errorStatus,
      });
    };

    return (
      <>
        <CustomContainer className={styles["delivery-container"]}>
          {deliveryOptionEnable && (
            <ReceiveType
              heading={
                labels.creditCheckout.deliveryDetails.lbl_receive_type_title
              }
              selectedType={selectedReceiveType}
              receiveTypes={receiveTypesOptions}
              handleReceiveType={handleReceiveType}
              tabDisable={tabDisable}
              id="checkout-credit-check-receive-type-select"
            />
          )}
          {/* <DeliveryTitle
            title="Standard Delivery"
            contents={titleContents}
            className={styles["standard-box"]}
            id={`checkout-standard-delivery`}
          /> */}
          {/* {(storePath.length > 0 || courierPath.length > 0) && (
            <DeliveryTitle
              contents={
                selectedReceiveType != "store" ? courierPath : storePath
              }
              className={styles["collectInStoreBox"]
              }
              id={`checkout-standard-delivery`}
              iconType={"dot"}
            />
          )} */}
          <DeliveryOptionTitle
            content={selectedReceiveType != "store" ? courierPath : storePath}
          />

          {selectedReceiveType == "store" &&
            Object.keys(customerPosition).length != 0 &&
            closestStoreLists.length !== 0 && (
              <FormHeading
                title="Stores closest to you"
                desc="These three stores close to you have your items in stock right now:"
                className={styles["storeCard"]}
              ></FormHeading>
            )}

          {selectedReceiveType == "store" && (
            <div className={styles["storeCard-container"]}>
              <StoreCard
                variant="closestStore"
                handleOnClick={closestStoreCardClickHandler}
                selectedStoreCard={selectedClosestStoreCard}
                data={closestStoreLists}
                geoLocationIsAllowed={
                  geoLocation?.allowed ? true : false
                }
              />
            </div>
          )}

          {selectedReceiveType == "store" && serviceDown && (
            <CustomContainer className={styles["serviceDown"]}>
              <img
                className={styles["serviceDown__icon"]}
                src={`${imagePrefix}/assets/images/warning-black.svg`}
              />
              <span>{labels.lbl_no_store_list_found}</span>
            </CustomContainer>
          )}

          {selectedReceiveType == "store" && (
            <FormHeading
              title="Which store would you like to collect from?"
              desc="Try searching for your town, suburb or favourite shopping centre"
              className={styles["storeCard-list"]}
            ></FormHeading>
          )}

          {selectedReceiveType == "store" && (
            <CustomContainer className={"d-none " + styles["search-wrapper"]}>
              <CustomContainer>
                <ContentSearchBox
                  className={styles["search-wrapper__input"]}
                  placeholderText="Type here to search"
                  icon="$black40"
                  variant="store-search"
                  setFinalAddress={setFinalAddress}
                  passSuggestedData={(filteredAddressData) =>
                    passSuggestedData(filteredAddressData)
                  }
                  pageName={`checkout: delivery: ${customerStatus}`}
                  analyticFormName="delivery address"
                ></ContentSearchBox>
              </CustomContainer>
            </CustomContainer>
          )}

          {searchResult == true && selectedReceiveType == "store" && (
            <CustomContainer>
              <CustomContainer className={styles["result"]}>
                <LabelText
                  className={styles["result-label"]}
                >{`0 - 0 of 0 results `}</LabelText>
                <CustomContainer className={styles["dropdown-container"]}>
                  <LabelText className={styles["dropdown-label"]}>
                    {labels.lbl_sort_by}
                    {":"}
                  </LabelText>
                  <DropDownComponent
                    data={
                      geoLocation?.allowed
                        ? dropdownWithDistance
                        : dropdownValues
                    }
                    handleSelect={handleSelected}
                    menuClassName="sort-menu"
                    selectedValue={selected}
                    id="sort-menu"
                  />
                </CustomContainer>
              </CustomContainer>
              <CustomContainer className={styles["empty-wrapper"]}>
                <EmptyProductsContainer
                  message={
                    "We couldn’t find any results for your search term. Please try again."
                  }
                  ctaHidden={true}
                />
              </CustomContainer>
            </CustomContainer>
          )}

          {selectedReceiveType == "store" && storeListsFromSearch.length !== 0 && (
            <CustomContainer className={styles["result"]}>
              {storeListsFromSearch.length > 0 && (
                <LabelText className={styles["result-label"]}>{`1 - ${
                  storeListsFromSearch.length > 3
                    ? dataSize
                    : storeListsFromSearch.length
                } of ${storeListsFromSearch.length} results `}</LabelText>
              )}
              {storeListsFromSearch.length === 0 && (
                <LabelText
                  className={styles["result-label"]}
                >{`0 - 0 of 0 results `}</LabelText>
              )}
              <CustomContainer className={styles["dropdown-container"]}>
                <LabelText className={styles["dropdown-label"]}>
                  {labels.lbl_sort_by}
                  {":"}
                </LabelText>
                <DropDownComponent
                  data={
                    geoLocation?.allowed ? dropdownWithDistance : dropdownValues
                  }
                  handleSelect={handleSelected}
                  menuClassName="sort-menu"
                  selectedValue={selected}
                  id="sort-menu"
                />
              </CustomContainer>
            </CustomContainer>
          )}

          {selectedReceiveType == "store" &&
            storeListsFromSearch &&
            storeListsFromSearch.length < 0 && (
              <EmptyProductsContainer
                message={
                  "We couldn’t find any results for your search term. Please try again."
                }
                ctaHidden={true}
              />
            )}

          {selectedReceiveType == "store" && storeListsFromSearch.length > 0 && (
            <CustomContainer className={styles["storeCard-container"]}>
              <StoreCard
                variant="searchedStore"
                handleOnClick={storeCardClickHandler}
                selectedStoreCard={selectedStoreCard}
                data={storeListsFromSearch}
                onSizeChange={handleSizeChange}
                geoLocationIsAllowed={
                  geoLocation?.allowed ? true : false
                }
              />
            </CustomContainer>
          )}

          {selectedReceiveType != "store" && (
            <Form noValidate id="deliveryForm">
              {totalDeliveryAddress > 0 && (
                <FormHeading
                  title="Delivery address"
                  desc="Where would you like us to deliver your order?"
                  id={`checkout-form-delivery-address`}
                ></FormHeading>
              )}

              {deliveryAddresslists.length > 0 && (
                <CustomContainer className={styles["tiles-section"]}>
                  {deliveryAddresslists.map((item, index) => (
                    <AddressTile
                      type="delivery"
                      variant="edit"
                      data={item}
                      key={index}
                      handleOnEdit={showModal}
                      handleOnDelete={displyConfirmModal}
                      handleOnClick={addressTileClickHandler}
                      selectedAddress={selectedDeliveryAddress}
                      id={`checkout-delivery-address-tile-${index}`}
                    />
                  ))}
                </CustomContainer>
              )}

              {totalDeliveryAddress > 0 && (
                <AddAddress
                  type="delivery"
                  className={styles["tiles-section"]}
                  data={{
                    desktop_button: "Add delivery address",
                    mob_button: "Add another address",
                  }}
                  handleOnClick={showModal}
                  id={`checkout-form-add-delivery-address`}
                />
              )}
              {(totalDeliveryAddress == 0 || applicationType !== "normal") && (
                <>
                  <CustomContainer
                    className={`${isGuestUser ? "d-flex flex-column" : ""}`}
                  >
                    {totalDeliveryAddress == 0 && (
                      <>
                        <FormHeading
                          title="Delivery address"
                          desc="Where would you like us to deliver your order?"
                          id={`checkout-form-delivery-address`}
                        ></FormHeading>
                        {state.fieldValues["delivery"].addressType !==
                          POSTAL_ADDRESS_TYPE && (
                          <CustomContainer className={"d-none " + styles["search-wrapper"]}>
                            <ContentSearchBox
                              className={styles["search-wrapper__input"]}
                              placeholderText="Search for your address"
                              icon="blue"
                              variant="address-search"
                              setFinalAddress={setFinalAddress}
                              pageName={`checkout: delivery: ${customerStatus}`}
                              analyticFormName="delivery address"
                            />
                          </CustomContainer>
                        )}
                        <DeliveryAddress
                          formName="delivery"
                          applicationType={applicationType}
                          validations={state.validations["delivery"]}
                          fieldValues={state.fieldValues["delivery"]}
                          fieldErrors={state.fieldErrors["delivery"]}
                          fieldErrorsMessage={state.fieldErrorsMessage["delivery"]}
                          readOnlyValues={state.readOnlyValues["delivery"]}
                          stateTypesOptions={stateTypesOptions}
                          onChangeHandler={handleChange}
                          onBlurHandler={handleBlur}
                          isGuestUser={isGuestUser}
                          containerClassName={`${styles["section"]}`}
                        />
                      </>
                    )}

                    <CustomContainer
                      className={`${isGuestUser ? styles["order-1"] : ""}`}
                    >
                      <FormHeading
                        title={
                          applicationType == "normal"
                            ? "Your details"
                            : "Your contact details"
                        }
                        desc={
                          applicationType == "normal"
                            ? "We need your personal details to process this order"
                            : "Where can the courier contact you when delivering your order?"
                        }
                        id={`checkout-form-details`}
                      ></FormHeading>
                      <PersonDetails
                        formName="details"
                        applicationType={applicationType}
                        fieldValues={state.fieldValues["details"]}
                        fieldErrors={state.fieldErrors["details"]}
                        fieldErrorsMessage={state.fieldErrorsMessage["details"]}
                        readOnlyValues={state.readOnlyValues["details"]}
                        onChangeHandler={handleChange}
                        onBlurHandler={handleBlur}
                        isGuestUser={isGuestUser}
                        className={styles["section"]}
                        formInfo={contactFormInfo}
                      ></PersonDetails>
                    </CustomContainer>

                    {showContactDetails && applicationType == "normal" && (
                      <>
                        <FormHeading
                          title="Your contact details"
                          desc="Who can we contact when we deliver at this address?"
                          id={`checkout-form-contact-details`}
                        ></FormHeading>

                        <PersonDetails
                          formName="contactDetails"
                          applicationType={applicationType}
                          fieldValues={state.fieldValues["contactDetails"]}
                          fieldErrors={state.fieldErrors["contactDetails"]}
                          fieldErrorsMessage={
                            state.fieldErrorsMessage["contactDetails"]
                          }
                          readOnlyValues={
                            state.readOnlyValues["contactDetails"]
                          }
                          onChangeHandler={handleChange}
                          onBlurHandler={handleBlur}
                          className={styles["section"]}
                        ></PersonDetails>
                      </>
                    )}
                  </CustomContainer>
                </>
              )}

              {applicationType == "normal" && (
                <CustomContainer>
                  <FormHeading
                    title="Billing address"
                    desc="Where would you like us to send your bill?"
                    id={`checkout-form-billing-address`}
                  ></FormHeading>
                  {isGuestUser && (
                    <>
                      <BillingAddress
                        formName="billing"
                        validations={state.validations["billing"]}
                        fieldValues={state.fieldValues["billing"]}
                        fieldErrors={state.fieldErrors["billing"]}
                        fieldErrorsMessage={state.fieldErrorsMessage["billing"]}
                        readOnlyValues={state.readOnlyValues["billing"]}
                        addressTypesOptions={addressTypesOptions}
                        stateTypesOptions={stateTypesOptions}
                        onChangeHandler={handleChange}
                        onBlurHandler={handleBlur}
                        showBillingAddress={showBillingAddress}
                        containerClassName={`${styles["section"]}`}
                      ></BillingAddress>
                    </>
                  )}
                </CustomContainer>
              )}
              {!isGuestUser && applicationType == "normal" && (
                <AddressTile
                  type="billing"
                  className={`${styles["tiles-section"]}`}
                  data={{
                    address_name: "Same as delivery address",
                    id: true,
                  }}
                  variant="default"
                  handleOnClick={addressTileClickHandler}
                  selectedAddress={selectedBillingAddress}
                  id={`checkout-billing-address-tile-same-as-delivery`}
                />
              )}
              {billingAddresslists.length > 0 && applicationType == "normal" && (
                <CustomContainer className={`${styles["tiles-section"]}`}>
                  {billingAddresslists.map((item, index) => (
                    <AddressTile
                      type="billing"
                      variant="edit"
                      data={item}
                      key={index}
                      handleOnEdit={showModal}
                      handleOnDelete={displyConfirmModal}
                      handleOnClick={addressTileClickHandler}
                      selectedAddress={selectedBillingAddress}
                      id={`checkout-billing-address-tile-${index}`}
                    />
                  ))}
                </CustomContainer>
              )}
              {!isGuestUser && applicationType == "normal" && (
                <AddAddress
                  type="billing"
                  className={styles["tiles-section"]}
                  data={{
                    desktop_button: "Add billing address",
                    mob_button: "Add another address",
                  }}
                  handleOnClick={showModal}
                  id={`checkout-form-add-billing-address`}
                />
              )}

            </Form>
          )}
        </CustomContainer>

        <CheckoutFormsModal
          show={modalShow}
          hide={hideModal}
          formType={modalType}
          variant={modalVariant}
          values={modalValues}
          addressTypes={addressTypesOptions}
          statesTypes={stateTypesOptions}
          countryCode={countryCode}
          countryName={countryName}
          cartId={cartId}
          step="delivery"
          pageName={`checkout: delivery: ${customerStatus}`}
          isGuestUser={isGuestUser}
          applicationType={applicationType}
        ></CheckoutFormsModal>

        {showConfirmModal ? (
          <ConfirmModal
            show={showConfirmModal}
            subtext="You’re about to delete this address:"
            text={confirmModalContent}
            handleConfirm={approveConfirmModel}
            handleCancel={cancelConfirmModel}
            confirmLabel="Yes, delete this address"
          />
        ) : null}
      </>
    );
  }
);

CheckoutDelivery.propTypes = {
  continueDisable: PropTypes.func,
  addressTypes: PropTypes.array,
  statesTypes: PropTypes.array,
  countryCode: PropTypes.string,
  countryName: PropTypes.string,
  cartId: PropTypes.string,
  navigate: PropTypes.func,
  isGuestUser: PropTypes.bool,
  profileData: PropTypes.any,
  customerStatus: PropTypes.string,
  applicationType: PropTypes.string,
};

CheckoutDelivery.defaultProps = {
  addressTypes: [],
  statesTypes: [],
  isGuestUser: false,
  applicationType: "normal",
};

const mapStateToProps = (state) => {
  return {
    profileLoading: state.navDetails.isProfileLoading,
    deliveryDetails: state.creditCheckDetails.deliveryDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    upgradeResponse: state.upgrade.upgradeResponse,
    cartDetails: state.cartDetails,
    geoLocation: state.geoLocation,
  };
};

const mapDispatchToProps = {
  setReLogin,
  setGeoLocationStatus,
  setGeoLocationPosition,
  setStoreDetails,
  setChangeStore,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(CheckoutDelivery);
